import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {CreateEditITProcessModal} from '@ey/canvascoreservices';
import {currentResource, labels} from '../../../util/utils';
import {useEngagementId} from '../../../util/customHooks';
import {createITProcess, getITProcessById, updateItProcess} from '../../../actions/ITProcess/itprocessactions';
import {clearErrors} from '../../../actions/erroractions';
import Utility from '../../../util/utilityfunctions';

export default function CreateEditITProcessModalWrapper(props) {
	const {
		bodyId,
		entityId,
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		entitySelector,
		parentEntitiesSelector,
		onClose,
		onSaveComplete,
		onEntityCreated,
		onEntityModified,
		viewOnly = false
	} = props;

	const dispatch = useDispatch();
	const engagementId = useEngagementId();

	const getITProcessByIdQueryString = {includeITApp: true, includeControl: true, includeITRisk: true, includeITControl: true};

	let _entitySelector = entitySelector || ((state) => state.bodiesSpecial?.itProcesses.byId[entityId]);
	const itProcess = useSelector((state) => _entitySelector(state));

	const handleOnEntityCreated = (itProcess) => {
		let promise = Promise.resolve();

		if (onEntityCreated) {
			promise = onEntityCreated(itProcess);
		}
		return promise;
	};

	const handleOnEntityEdited = (itProcess) => {
		let promise = Promise.resolve();

		if (onEntityModified) {
			promise = onEntityModified(itProcess);
		}
		return promise;
	};

	const addItProcess = (data) => {
		const ITProcessDetail = {
			ITProcessName: data.iTProcessName,
			taskTitle: labels.taskTitle,
			taskDescription: labels.taskDescription
		};
		return dispatch(createITProcess(engagementId, ITProcessDetail, bodyId)).then((response) => {
			onSaveComplete && onSaveComplete(response);
			handleOnEntityCreated(response);
		});
	};

	const editItProcess = (itProcessId, data) => {
		return dispatch(updateItProcess(engagementId, data, itProcessId)).then((response) => {
			onSaveComplete && onSaveComplete();
			handleOnEntityEdited(response);
		});
	};

	return (
		<>
			{isCreate && (
				<CreateEditITProcessModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditITProcessLabels}
					createITProcessAction={(data) => addItProcess(data)}
					clearITProcess={() => {
						dispatch(clearErrors());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					theme={Utility.getTheme()}
				/>
			)}
			{isEdit && (
				<CreateEditITProcessModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={currentResource.CreateEditITProcessLabels}
					itProcessId={entityId}
					editITProcessAction={(itProcessId, data) => editItProcess(itProcessId, data)}
					clearITProcess={() => {
						dispatch(clearErrors());
						setTimeout(() => {
							onClose && onClose();
						}, 600);
					}}
					itProcessName={itProcess.itProcessName}
					getITProcessById={getITProcessById(Number(engagementId), entityId, getITProcessByIdQueryString)}
					viewOnly={viewOnly}
					theme={Utility.getTheme()}
				/>
			)}
		</>
	);
}

CreateEditITProcessModalWrapper.propTypes = {
	isCreate: PropTypes.bool,
	isEdit: PropTypes.bool,
	showModal: PropTypes.bool.isRequired,
	setShowModal: PropTypes.func.isRequired,
	itProcessId: PropTypes.number,
	onClose: PropTypes.func
};
